import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { FCM } from '@ionic-native/fcm/ngx';
import * as firebase from 'firebase';
import { UniqueDeviceID } from '@ionic-native/unique-device-id/ngx';

@Injectable({
  providedIn: 'root'
})
export class FcmService {

  constructor(private fcm: FCM,
    private platform: Platform,
    private uniqueDeviceID: UniqueDeviceID) {}

  async setToken(uId: any) {
    let token;

    if (this.platform.is('android')) {
    token = await this.fcm.getToken();
    }

    if (!this.platform.is('ios')) {
    token = await this.fcm.getToken();
    // await this.fcm.getToken().messaging().requestPermission();
    }

    this.saveToken(token, uId);
  }

  private saveToken(token, uId) {
    if (!token) {
      return;
    }
    // initialize collection ref
    const db = firebase.firestore();
    const devicesRef = db.collection('DeviceCollection');

    // create an object to store token and other details in DeviceCollection
    let data = {
    token,
    uId : uId, // uid is users authentication Id
    timeStamp : firebase.firestore.FieldValue.serverTimestamp()
    };

    // get user's device token
    this.uniqueDeviceID.get()
    .then((udId: any) => {
      // userTypeId is users Type unique id - corresponding to device
      data['udId'] = udId;

      // do update - if token already exist by uuid and uid
      // add new token - if token not found by uuid and uid
      devicesRef.where('uId', '==', uId)
      .get()
      .then(function(querySnapshot) {
        if (querySnapshot.empty) {
          // do add new document
          devicesRef.add(data);
        } else {
          const documentId = querySnapshot.docs[0].id;
          // token document found by uid & uuid - do update new token
          devicesRef.doc(documentId).update(data);
        }
      })
      .catch(function(error) {
        console.log('Error getting documents: ', error);
      });
    })
    .catch((error: any) => {
      console.log(error);
      // do add new document
      // do update - if token already exist by uuid and uid
      // add new token - if token not found by uuid and uid
      devicesRef.where('uId', '==', uId)
      .get()
      .then(function(querySnapshot) {
        if (querySnapshot.empty) {
          // do add new document
          devicesRef.add(data);
        } else {
          const documentId = querySnapshot.docs[0].id;
          // token document found by uid & uuid - do update new token
          devicesRef.doc(documentId).update(data);
        }
      })
      .catch(function(error) {
        console.log('Error getting documents: ', error);
      });
    });
  }

onNotification() {
return this.fcm.onNotification();
}

}
